import React, { FC } from 'react'
import WrapperImage from '../../../../global/wrapperImage'
import { PartnersLocatorFilters } from '../../partnerListings'

type Props = {
  handleFilterClick: any
  handleFilterItemClick: any
  btnPrimaryIcon: string
  handleResetFilters: any
  isCategoryFilterActive: boolean
  categoryFilter: string
  technologyPartnersCategories: any
  partnersListingNameTypes: any
  becomeAPartnerObj: any
  arrowLongRight: any
}

const Filters: FC<Props> = ({
  handleFilterClick,
  handleFilterItemClick,
  btnPrimaryIcon,
  handleResetFilters,
  isCategoryFilterActive,
  categoryFilter,
  technologyPartnersCategories,
  partnersListingNameTypes,
  becomeAPartnerObj,
  arrowLongRight,
}) => {
  return (
    <PartnersLocatorFilters>
      <div className="PartnersLocator__filtersContainer">
        <div className="PartnersLocator__filter">
          <span className="PartnersLocator__filterTitle">Category</span>
          <div
            id="category"
            className={`PartnersLocator__filterClosed ${isCategoryFilterActive ? 'is-active' : ''}`}
            onClick={handleFilterClick}>
            <span>{categoryFilter ? categoryFilter : 'Show All'}</span>
          </div>

          <div
            className={`PartnersLocator__filterOpened ${
              isCategoryFilterActive ? 'is-active' : ''
            }`}>
            <ul>
              <li key="show_all" data-item="category" onClick={handleFilterItemClick}>
                Show all
              </li>

              {technologyPartnersCategories
                ?.filter((item: any) => (item ? true : false))
                ?.sort((a: any, b: any) => {
                  if (a < b) {
                    return -1
                  }
                })
                ?.map((category: any, index: any) => (
                  <li
                    key={`category_${index}`}
                    data-item="category"
                    onClick={handleFilterItemClick}>
                    {category}
                  </li>
                ))}
            </ul>
          </div>
        </div>

        {/* Reset filters */}
        <div className="PartnersLocator__filter">
          <span
            id="resetFilters"
            className={`PartnersLocator__resetFilters ${
              categoryFilter ? 'PartnersLocator__resetFilters--active' : ''
            }`}
            onClick={handleResetFilters}>
            Reset filters <i className="fa fa-times"></i>
          </span>
        </div>

        {/* Become a partner */}
        <div className="PartnersLocator__filter PartnersLocator__filter--desktop">
          <h4 className="PartnersLocator__becomePartnerTitle">
            Apply to become a{' '}
            {partnersListingNameTypes?.length >= 2 && partnersListingNameTypes[1]?.value
              ? partnersListingNameTypes[1]?.value
              : 'Technology Partner'}
          </h4>

          <p className="PartnersLocator__becomePartnerDesc">
            Join forces with UiPath to fast-track portfolio innovation, expand your capabilities and
            accelerate demand.
          </p>

          <a
            className="PartnersLocator__becomePartnerCTA Button Button--secondary"
            href={becomeAPartnerObj[1]?.value}
            rel=" noopener">
            {becomeAPartnerObj[0]?.value}
            <WrapperImage src={btnPrimaryIcon} alt="arrow" width={24} height={24} threshold={650} />
          </a>
        </div>

        <div className="PartnersLocator__filter PartnersLocator__filter--desktop">
          <h4 className="PartnersLocator__becomePartnerTitle">Access pre-built integrations</h4>
          <p className="PartnersLocator__becomePartnerDesc">
            Download pre-built integrations and other reusable components on the UiPath Marketplace.
          </p>

          <a
            className="PartnersLocator__becomePartnerCTA PartnersLocator__becomePartnerCTA--link"
            href="https://marketplace.uipath.com/"
            target="_blank"
            rel=" noopener">
            Go to the UiPath Marketplace
            <WrapperImage src={arrowLongRight} width={24} height={24} threshold={650} />
          </a>
        </div>
      </div>
    </PartnersLocatorFilters>
  )
}

export default Filters
